<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="headline">Daily credit card report</span>
      </v-card-title>
      <v-card-text>
       <v-row>
          <v-col>
            <v-menu
              v-model="fromDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="fmtFromDate"
                  label="From date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  clearable
                  @click:clear="searchCriteria.fromDate = null"></v-text-field>
              </template>
              <v-date-picker
                v-model="searchCriteria.fromDate"
                @input="fromDateMenu=false;setEndOfMonth();">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-menu
              v-model="toDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="fmtToDate"
                  label="To date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  clearable
                  @click:clear="searchCriteria.toDate = null"></v-text-field>
              </template>
              <v-date-picker
                v-model="searchCriteria.toDate"
                @input="toDateMenu=false">
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="px-4">
          <v-btn color="primary" class="d-print-none" @click="runReport()">Run Report</v-btn>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row>
      <v-container fluid fill-height>
        <v-card width="100vw">
          <v-data-table
            dense
            :headers="headers"
            :items="reportData"
            hide-default-footer
            disable-pagination>
            <template v-slot:item.fareAmount="{ item }">
              <span>{{item.fareAmount | toCurrency}}</span>
            </template>
            <template v-slot:item.bookingId="{ item }">
              <a :href="getEditBookingUrl(item.bookingId)" target="_blank">{{ item.bookingId }}</a>
            </template>
            <template slot="body.append">
              <tr class="grey lighten-1 font-weight-black">
                <td class="py-4" colspan="5">
                  Grand Total:  {{ sumValues(reportData, 'fareAmount') | toCurrency }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import storeConstants from '@/store/storeConstants';

export default {
  name: 'DailyBooking',
  data: () => ({
    reportData: [],
    toDateMenu: false,
    fromDateMenu: false,
    searchCriteria: {
      fromDate: null,
      toDate: null,
    },
    headers: [
      {
        text: 'Fare', value: 'fareAmount', align: 'right', width: '150px',
      },
      { text: 'Arrival', value: 'arriveDate', width: '150px' },
      { text: 'Departure', value: 'departDate', width: '150px' },
      { text: 'Customer Name', value: 'customerName', width: '150px' },
      { text: 'BookingId', value: 'bookingId', width: '150px' },
    ],
  }),
  mounted() {
    this.setCriteria();
  },
  methods: {
    ...mapActions([storeConstants.GET_REPORT_CREDIT_BOOKINGS]),
    runReport() {
      this.GET_REPORT_CREDIT_BOOKINGS(this.searchCriteria)
        .then((data) => {
          this.reportData = data;
        },
        (error) => {
          this.SET_ALERT_DETAILS({ alertText: error.response.data.error, showAlert: true });
        })
        .catch(() => {
        });
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      return this.$moment(date).format(this.DISPLAY_DATE_FORMAT);
    },
    setCriteria() {
      this.setStartOfMonth();
      this.setEndOfMonth();
    },
    sumField(key) {
      // sum data in give key (property)
      return this.reportData.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumValues(items, prop) {
      if (items == null || items.length === 0) return 0;
      return items.map(i => i[prop]).reduce((a, b) => a + b);
    },
    getEditBookingUrl(bookingId) {
      return `editBooking/${bookingId}`;
    },
    setStartOfMonth() {
      const startOfMonth = this.$moment().startOf('month').format(this.ISO_8601_FORMAT);
      this.searchCriteria.fromDate = startOfMonth;
    },
    setEndOfMonth() {
      const endOfMonth = this.$moment(this.searchCriteria.fromDate).endOf('month').format(this.ISO_8601_FORMAT);
      this.searchCriteria.toDate = endOfMonth;
    },
  },
  computed: {
    ...mapGetters([
      storeConstants.SHORT_DATE_FORMAT,
      storeConstants.DISPLAY_DATE_FORMAT,
      storeConstants.ISO_8601_FORMAT]),
    fmtFromDate() {
      return this.formatDate(this.searchCriteria.fromDate);
    },
    fmtToDate() {
      return this.formatDate(this.searchCriteria.toDate);
    },
  },
};

</script>
